import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxCodeHighlightComponent } from './ngx-code-highlight.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NgxCodeHighlightComponent],
  exports: [NgxCodeHighlightComponent]
})
export class NgxCodeHighlightModule {}
